import React, {useCallback, useEffect, useMemo, useState} from 'react'
import {useForm, useFormContext} from 'react-hook-form'

import {
  Button, Checkbox,
  Dialog,
  DialogActions,
  DialogContent, DialogContentText,
  DialogTitle, FormGroup, Grid, InputAdornment, TextField, Typography
} from '@material-ui/core'
import {Close, PhotoLibrary} from '@material-ui/icons'

import HookForm from '../../../components/common/HookForm'
import LoadingBackdrop from '../../../components/common/LoadingBackdrop'
import ChipsList from '../../../components/common/inputs/ChipsList'
import SelectInput from '../../../components/common/inputs/SelectInput'
import Switch from '../../../components/common/inputs/Switch'
// import Switch from '@mui/material/Switch';
import TextInput from '../../../components/common/inputs/TextInput'
import { useCreateEventItem } from '../../../mutations/useCreateEventItem'
import { useFetchLocationTags } from '../../../queries/events/useFetchLocationTags'
import styles from './AuctionItemsTable.module.css'
import {useEventState} from "../../../slices/eventSlice";
import MaskedInput from "../../../components/common/inputs/MaskedInput";
import Dropzone from "react-dropzone";
import {
  Divider,
  FormControl,
  FormControlLabel,
  InputLabel, ListItemText,
  MenuItem,
  OutlinedInput,
  Select, SelectChangeEvent,
  ToggleButton,
  ToggleButtonGroup
} from "@mui/material";
import NumberFormat from 'react-number-format'
import CustomMaskedInput from "../../../components/common/inputs/MaskedInput/CustomMaskedInput";
import imageCompression from "browser-image-compression";
import { SortableContainer, SortableElement, SortableHandle } from 'react-sortable-hoc';
import { arrayMoveImmutable } from 'array-move';
import axios from "axios";
import dayjs from "dayjs";

interface FormData {
  itemid: number
  itemnumber: string
  name: string
  shortdesc: string
  longdesc: string
  location: number
  taglistids: [{
    tag: number
  }]
  allowautobid: boolean
  donatedby: string
  donatedbyemail: string
  donationtypeid: number
  accountingcodeid: number
  fairmarketvalue: number
  startingbid: number
  minimumraise: number
  buyitnowprice: number
  buyItNowValueOnlineAuction: number
  buyItNowChangeOnlineOnly: number
  quantityunlimited: boolean
  quantity: number
  maxpurchasequantity: number
  imageloaded: boolean
  logo: string
  logourl: string
  logoremoved: boolean
  pickupinstructions: string
  active: string
  toggleItemType: string
}

const DragHandle = SortableHandle(({ photourl }: { photourl: string }) => (
  <div className={styles.photoWrapper} style={{ cursor: 'grab' }}>
    <img src={photourl} alt="" />
  </div>
));

const SortablePhoto = SortableElement(({ item, onRemove }: { item: any, onRemove: (id: any) => void }) => (
  <div style={{ userSelect: 'none', padding: 16, margin: '0 0 8px 0', background: '#ccc', zIndex: 9999 }}>
    <div><Close fontSize="small" onClick={() => onRemove(item.photoid)} /></div>
    <DragHandle photourl={item.photourl} />
  </div>
));

const SortablePhotoList = SortableContainer(({ items, onRemove, dropzoneNode }: { items: any[], onRemove: (id: any) => void, dropzoneNode: React.ReactNode }) => (
  <div style={{ display: 'flex', flexWrap: 'wrap', background: 'lightgrey', padding: 8 }}>
    {items.map((item, index) => (
      <SortablePhoto key={item.photoid} index={index} item={item} onRemove={onRemove} />
    ))}
    {dropzoneNode}
  </div>
));

export const AuctionItemsForm = ({ isOpen, setIsOpen, gridParams, reloadForm }) => {
  const formMethods = useForm<FormData>()
  // const { control, formState } = useFormContext()
  const eventState = useEventState()
  const title = gridParams ? "Edit Auction Item" : "Create Auction Item"
  const { setValue, watch, getValues, setError, clearErrors, setFocus } = formMethods
  const { reset } = formMethods
  const [tags, setTags] = useState<{ value: any; label: string }[]>([])
  const { data: locationAndTags } = useFetchLocationTags(Number(eventState.eventId))
  // const { data: donationTypes } = useFetchDonationTypes()
  const [quantityValue, setQuantityValue] = useState<number>(1)
  const [fairMarketValue, setFairMarketValue] = useState<number>(0)
  const [startingBidValue, setStartingBidValue] = useState<number>(0)
  const [buyItNowValue, setbuyItNowValue] = useState<number>(null)
  const [buyItNowValueOnlineAuction, setbuyItNowValueOnlineAuction] = useState<number>(null)
  const [buyItNowValueOnlineOnly, setbuyItNowValueOnlineOnly] = useState<number>(null)
  const [minimumRaiseValue, setMinimumRaiseValue] = useState<number>(1)
  const [tagSelection, setTagSelection] = React.useState<string[]>([]);
  const [buyItNowActive, setbuyItNowActive] = useState<boolean>(true)
  const [dialogMsg, setDialogMsg] = React.useState("")
  const watchLogo = watch('logourl')
  const allowautobidWatch = watch('allowautobid')
  const watchLogoData = watch('logo')
  const minNumberRegex = /^([1-9][0-9]{0,2}|1000)$/
  const [toggleItemType, setToggleItemType] = React.useState("online-auction");
  const [allowAutoBidValue, setAllowAutoBidValue] = useState<boolean>()
  const qtyUnlimited = watch('quantityunlimited')
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [resetKey, setResetKey] = useState(0);

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  }


  // drag and drop
  const initialItems = [];

  const [itemPhotos, setItemPhotos] = useState(initialItems);

  // useEffect(() => {
  //   console.log(itemPhotos)
  //
  //   if (itemPhotos && itemPhotos?.length > 0) {
  //     let body = {
  //       eventid: eventState.eventId,
  //       itemid: gridParams?.itemid
  //     }
  //
  //     body['photos'] = itemPhotos.map((photo, index) => (
  //         {
  //           photoid: photo.photodata ? null : photo.photoid,
  //           photodata: photo.photodata ? photo.photodata : '',
  //           photoorder: index+1
  //         }
  //     ))
  //
  //     axios.put('/eventitemphoto', body)
  //   }
  // }, [itemPhotos])

  const getPhotoItems = async () => {
    if (gridParams?.itemid) {
      const { data } = await axios.post('/eventitemphoto', {eventid: eventState.eventId, itemid: gridParams?.itemid})
      const parsedData = JSON.parse(data.jsonString)
      if (parsedData && parsedData?.itemphotos && parsedData?.itemphotos?.length > 0) {
        const newPhotosData = parsedData?.itemphotos.sort((a, b) => a.photoorder - b.photoorder);
        setItemPhotos(newPhotosData)
      }
    }
  }

  const onSortEnd = useCallback(({ oldIndex, newIndex }) => {
    setItemPhotos(photos => arrayMoveImmutable(photos, oldIndex, newIndex));
  }, []);


  useEffect(() => {
    if (qtyUnlimited) {
      setQuantityValue(0)
      setValue('quantity', 0)
    }
    else {
      setQuantityValue(1)
      setValue('quantity', 1)
    }
  }, [qtyUnlimited])

  useEffect(() => {
    if (allowautobidWatch) {
      setValue('quantity', 1)
    }
  }, [allowautobidWatch])

  const handleQuantityChange = (event) => {
    var maxQty = event.value
    if (maxQty > 25) {
      maxQty = 25
    }
    if (maxQty > 0) {
      setValue('maxpurchasequantity', maxQty)
    }

    setQuantityValue(event.value)
  }

  const handleFairmarketChange = (event) => {
    setFairMarketValue(event.floatValue)
  }

  const handleStartingBidChange = (event) => {
    setStartingBidValue(event.floatValue)
  }

  const handleBuyItNowChange = (event) => {

    if (event.floatValue <= 0 && (toggleItemType === 'buy-it-now-online' || toggleItemType === 'buy-it-now-in-person')) {
      setbuyItNowValue(event.floatValue)
      setError('buyitnowprice', { type: 'required', message: 'Buy it now price is required for Online Items.' })
      return
    }

    setbuyItNowValue(event.floatValue)
  }

  const handleBuyItNowChangeOnlineAuction = (event) => {
    if (event.floatValue <= 0 && (toggleItemType === 'buy-it-now-online' || toggleItemType === 'buy-it-now-in-person')) {
      setbuyItNowValueOnlineAuction(event.floatValue)
      setError('buyitnowprice', { type: 'required', message: 'Buy it now price is required for Online Items.' })
      return
    }
    setbuyItNowValueOnlineAuction(event.floatValue)
  }

  const handleBuyItNowChangeOnlineOnly = (event) => {
    if (event.floatValue <= 0 && (toggleItemType === 'buy-it-now-online' || toggleItemType === 'buy-it-now-in-person')) {
      setbuyItNowValueOnlineOnly(event.floatValue)
      setError('buyItNowChangeOnlineOnly', { type: 'required', message: 'Buy it now price is required for Online Items.' })
      return
    }

    setbuyItNowValueOnlineOnly(event.floatValue)
  }

  const handleMinimumRaiseChange = (event) => {
    setMinimumRaiseValue(event.floatValue)
  }

  useEffect(() => {
    setItemPhotos([])
    getPhotoItems()

    let selectedTags = []
    let selectedTagsNames= []
    gridParams?.taglistids.forEach(tagId => {
      const tagToAdd = locationAndTags?.tags?.find(tag => tag.id === tagId);

      if (tagToAdd && tagToAdd.active) {
        selectedTags.push({value: tagToAdd.id, label: tagToAdd.name})
        selectedTagsNames.push(tagToAdd.name)
      }
    })
    setTags(selectedTags)
    setTagSelection(selectedTagsNames)



    setFairMarketValue(gridParams ? gridParams.fairmarketvalue : 0)
    setStartingBidValue(gridParams ? gridParams.startingbid : 0)
    setMinimumRaiseValue(gridParams ? gridParams.minimumraise : 1)
    setbuyItNowValue(gridParams ? gridParams.buyitnowprice : null)
    setbuyItNowValueOnlineAuction(gridParams ? gridParams.buyitnowprice : null)
    setbuyItNowValueOnlineOnly(gridParams ? gridParams.buyitnowprice : null)

    setQuantityValue(gridParams?.quantity)
    setAllowAutoBidValue(gridParams ? gridParams.allowautobid : false)


    if (gridParams && gridParams.itemtype === 1) {
      setToggleItemType('online-auction')
    }
    else if (gridParams && gridParams.itemtype === 2) {
      setToggleItemType('live-auction')
    }
    else if (gridParams && gridParams.itemtype === 3) {
      setToggleItemType('buy-it-now-online')
    }
    else if (gridParams && gridParams.itemtype === 4) {
      setToggleItemType('buy-it-now-in-person')
    }

    reset({
      itemid: (gridParams ? gridParams.itemid : 0),
      itemnumber: (gridParams ? gridParams.itemnumber : ''),
      name: (gridParams ? gridParams.name : ''),
      shortdesc: (gridParams ? gridParams.shortdesc : ''),
      longdesc: (gridParams ? gridParams.longdesc : ''),
      location: (gridParams ? gridParams.locationid : 0),
      taglistids: (gridParams ? gridParams.taglistids : []),
      allowautobid: (gridParams ? gridParams.allowautobid : false),
      donatedby: (gridParams ? gridParams.donatedby : ''),
      donatedbyemail: (gridParams ? gridParams.donatedbyemail : ''),
      donationtypeid: ((gridParams && gridParams.donationtypeid) ? gridParams.donationtypeid : 0),
      accountingcodeid: ((gridParams && gridParams.accountingcodeid)  ? gridParams.accountingcodeid : 0),
      fairmarketvalue: (gridParams ? gridParams.fairmarketvalue : 0),
      startingbid: (gridParams ? gridParams.startingbid : 0),
      minimumraise: (gridParams ? gridParams.minimumraise : 1),
      buyitnowprice:(gridParams && gridParams.buyitnowprice > 0 ? gridParams.buyitnowprice : null),
      buyItNowValueOnlineAuction: (gridParams && gridParams.buyitnowprice > 0 ? gridParams.buyitnowprice : null),
      buyItNowChangeOnlineOnly:(gridParams && gridParams.buyitnowprice > 0 ? gridParams.buyitnowprice : null),
      quantityunlimited: (gridParams ? gridParams.quantityunlimited : false),
      quantity: (gridParams ? gridParams.quantity : 1),
      maxpurchasequantity: (gridParams ? gridParams.maxpurchasequantity : 1),
      imageloaded: (gridParams ? gridParams.imageloaded : false),
      logo: (gridParams ? gridParams.logo : ''),
      logourl: (gridParams ? gridParams.logourl : ''),
      logoremoved: false,
      pickupinstructions: (gridParams ? gridParams.pickupinstructions : ''),
      active: (gridParams ? (gridParams.active ? 'Active' : 'Inactive') : 'Active'),
    })
  }, [reloadForm, locationAndTags])
  
  const tagOptions = useMemo(
    () =>
      locationAndTags?.tags?.filter((e) => e.active === true).map((tag) => {
          return { value: tag.id, label: tag.name }
      }),
    [locationAndTags]
  )

  const locations = locationAndTags ? locationAndTags : { locations:[] }

  const locationOptions = useMemo(
      () =>
          locations.locations?.filter((e) => e.active === true).map((location) => {
            return { value: location.id, label: location.name }
          }),
      [locationAndTags]
  )

  const donationnTypes = locationAndTags ? locationAndTags : { donationtype:[] }
  const donationTypeOptions = () => {
    const dtRows = donationnTypes.donationtype?.filter((e) => e.active === true).map((types) => {
      return {value: types.id, label: types.name}
    })
    if (dtRows && dtRows.length > 0) {
      return [{value: 0, label: 'None'}, ...dtRows]
    }
    else {
      return [{value: 0, label: 'None'}]
    }
  }

  const accountingTypes = locationAndTags ? locationAndTags : { accountingcode:[] }
  const accountingCodeOptions = () => {
    const dtRows = accountingTypes.accountingcode?.filter((e) => e.active === true).map((types) => {
      return {value: types.id, label: types.name}
    })
    if (dtRows && dtRows.length > 0) {
      return [{value: 0, label: 'None'}, ...dtRows]
    }
    else {
      return [{value: 0, label: 'None'}]
    }
  }


  const createMutation = useCreateEventItem()

  const onSubmit = async (data: FormData) => {
    if (toggleItemType === 'online-auction' && data.location === 0 ) {
      setError('location', { type: 'required', message: 'Location is required' })
      return
    }

    if (buyItNowValue <= 0 && toggleItemType === 'buy-it-now-in-person') {
      setError('buyitnowprice', { type: 'required', message: 'Buy it now price is required for Online Items.' })
      return
    }

    if (buyItNowValueOnlineOnly <= 0 && toggleItemType === 'buy-it-now-online') {
      setError('buyItNowChangeOnlineOnly', { type: 'required', message: 'Buy it now price is required for Online Items.' })
      return
    }

    var tagsToSave = []
    locationAndTags?.tags?.forEach(tag => {
      if (tagSelection.find((item) => item === tag.name)) {
        tagsToSave.push(tag.id)
      }
    })

    const locs = locationAndTags?.locations?.filter(item => {
      return data.location === item.id
    });

    var finalData = gridParams ? { ...data, eventid: Number(eventState.eventId) } : { ...data, eventid: Number(eventState.eventId) }

    var localItemType = 1
    var buyItNowVal = buyItNowValue
    if (toggleItemType === 'online-auction') {
      localItemType = 1
      buyItNowVal = buyItNowValueOnlineAuction
    }
    else if (toggleItemType === 'live-auction') {
      localItemType = 2
    }
    else if (toggleItemType === 'buy-it-now-online') {
      localItemType = 3
      buyItNowVal = buyItNowValueOnlineOnly
    }
    else if (toggleItemType === 'buy-it-now-in-person') {
      localItemType = 4
    }

    const { data: response } = await createMutation.mutateAsync(    {
      eventid: Number(eventState.eventId),
      itemid: Number(finalData.itemid),
      itemnumber: finalData.itemnumber,
      name: finalData.name,
      shortdesc: finalData.shortdesc,
      longdesc: finalData.longdesc,
      locationid: (locs && locs.length > 0 ? locs[0].id : 0),
      taglistids: tagsToSave,
      allowautobid: finalData.allowautobid,
      donatedby: finalData.donatedby,
      donatedbyemail: finalData.donatedbyemail,
      donationtypeid: (finalData.donationtypeid && finalData.donationtypeid.toString().length > 0 && finalData.donationtypeid.toString() !== 'none' ? finalData.donationtypeid : 0),
      accountingcodeid: (finalData.accountingcodeid && finalData.accountingcodeid.toString().length > 0 && finalData.accountingcodeid.toString() !== 'none' ? finalData.accountingcodeid : 0),
      fairmarketvalue: fairMarketValue,
      startingbid: startingBidValue,
      minimumraise: minimumRaiseValue,
      buyitnowprice: buyItNowVal,
      quantityunlimited: finalData.quantityunlimited,
      quantity: Number(quantityValue),
      maxpurchasequantity: Number(finalData.maxpurchasequantity),
      imageloaded: finalData.imageloaded,
      logo: watchLogoData,
      logourl: "",
      logoremoved: finalData.logoremoved,
      pickupinstructions: finalData.pickupinstructions,
      active: finalData.active === 'Active',
      itemtype: localItemType
    })

    if (itemPhotos && itemPhotos?.length > 0) {
      const parsedResponse = JSON.parse(response?.jsonString)
      let body = {
        eventid: eventState.eventId,
        itemid: parsedResponse?.itemid
      }

      body['photos'] = itemPhotos.map((photo, index) => (
          {
            photoid: photo.photodata ? null : photo.photoid,
            photodata: photo.photodata ? photo.photodata : '',
            photoorder: index+1
          }
      ))

      axios.put('/eventitemphoto', body)
    }

    const parsedResponse = JSON.parse(response?.jsonString)
    if (parsedResponse?.status === 'failure') {
      setDialogMsg(parsedResponse.message)
    }
    else {
      setIsOpen(false)
    }
  }

  const closeDialog = () => {
    setDialogMsg("")
  }

  const generateRandomInt = (min, max) => {
    // Generates a random integer between min (inclusive) and max (inclusive)
    return Math.floor(Math.random() * (max - min + 1)) + min;
  };

  const onLogoDrop = async (files: File[]) => {
    if (files && files.length > 0) {
      setIsLoading(true)
      const options = {
        maxSize: 1,
        maxWidthOrHeight: 1920,
        useWebWorker: true,
      }
      files.map(async (file) => {
        const compressedFile = await imageCompression(file, options)

        const url = window.URL.createObjectURL(compressedFile);

        const fileReader = new FileReader()
        fileReader.onload = function (event) {
          const data = event.target.result as string
          setItemPhotos(prevArray => [...prevArray, {photoid: generateRandomInt(1, 999999999).toString(), photourl: url, photodata: data.split(';base64,')[1]}])
          setIsLoading(false)
        }

        fileReader.readAsDataURL(compressedFile)
      })
    }

    setResetKey(resetKey +1)
  }

  const currencyFormat = (num) => {
    return '$' + num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
  }

  const clickRemoveLogo = (photoid) => {
    const newPhotos = itemPhotos.filter(item => item.photoid != photoid)
    setItemPhotos(newPhotos)
  }

  const handleTagChange = (event: SelectChangeEvent<typeof tagSelection>) => {
    const {
      target: { value },
    } = event;
    var values = []
    if (typeof value === 'string') {
      values = value.split(',')
    }
    else {
      value?.forEach(v => {
        if (v.length > 0) {
          values.push(v)
        }
      })
    }

    setTagSelection(values)
  }

  const handleTypeChange = (
      event: React.MouseEvent<HTMLElement>,
      newAlignment: string
  ) => {
    if (newAlignment !== null) {
      const loc : any = getValues('location')
      if (newAlignment === 'online-auction' && loc === 'none') {
        setError('location', { type: 'required', message: 'Location is required' })
      }
      else if (newAlignment == 'live-auction') {
        setQuantityValue(1)
      }

      setToggleItemType(newAlignment)
    }
  }

  const handleAllowAutoBidChange = (event) => {
    // localStorage.setItem('activeOnly', event.target.checked)
    // if (event.target.checked) {
    //   setEvents(data.filter((e) => e.active === true))
    // } else {
    //   setEvents(data)
    // }
  }
  // const { errors } = formState

  return (
    <Dialog open={isOpen} maxWidth="xl" className={styles.dialog}>
      <DialogTitle>{title}</DialogTitle>
      <LoadingBackdrop open={isLoading} />
      <>
        <Dialog
            open={dialogMsg.length > 0}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {dialogMsg}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={closeDialog}>Ok</Button>
          </DialogActions>
        </Dialog>
      </>
      <DialogContent>
        <HookForm
          methods={formMethods}
          onSubmit={onSubmit}
          className={styles.itemsForm}
          formProps={{ id: 'items-form' }}>
          <TextInput name="itemnumber" label="Item Number" required tooltipText={'Unique number or code to identify an item. Can contain numbers or letters.'}/>
          <TextInput name="name" label="Name" required tooltipText={'The item name that will be used in the item listing and detail page.'} />
          <TextInput
            name="shortdesc"
            label="Short Description"
            textFieldProps={{ multiline: true, rows: 3, rowsMax: 10 }}
            tooltipText={'The description of an item that is visible on the item detail page.'}
          />
          <TextInput
            name="longdesc"
            label="Description"
            textFieldProps={{ multiline: true, rows: 8, rowsMax: 20 }}
            tooltipText={'The larger description section when more space is needed that is initially hidden until clicked.'}
          />
          <TextInput
              name="pickupinstructions"
              label="Pickup Instructions"
              textFieldProps={{ multiline: true, rows: 2, rowsMax: 10 }}
              tooltipText={'Tell buyers what they need to do to receive this item.'}
          />
          <SelectInput
            name="donationtypeid"
            label="Donation Type"
            options={donationTypeOptions()}
            includeNone={false}
            tooltipText={'Used for the item’s donation record in DonorSnap or your donor management system.'}
          />
          <SelectInput
              name="accountingcodeid"
              label="Accounting Code 1"
              options={accountingCodeOptions()}
              includeNone={false}
              tooltipText={'Used for the item’s accounting code in DonorSnap or your donor management system.'}
          />
          <FormControl style={{height: 45}}>
            <InputLabel>Enter a tag</InputLabel>
            <Select
                labelId="demo-multiple-checkbox-label"
                id="demo-multiple-checkbox"
                name="tags"
                multiple
                style={{height: 45}}
                value={tagSelection}
                onChange={handleTagChange}
                input={<OutlinedInput label="Enter a Tag" />}
                renderValue={(selected) => selected.join(', ')}
                MenuProps={MenuProps}
            >
              {locationAndTags?.tags?.filter((e) => e.active === true).map((item) => (
                  <MenuItem key={item.id} value={item.name}>
                    <Checkbox color="primary" checked={tagSelection.indexOf(item.name) > -1} />
                    <ListItemText primary={item.name} />
                  </MenuItem>
              ))}
            </Select>
          </FormControl>
          {/*<ChipsList*/}
          {/*  list={tags}*/}
          {/*  setList={setTags}*/}
          {/*  options={tagOptions}*/}
          {/*  label="Enter a Tag"*/}
          {/*  tooltipText={'Categorize your items so that users can filter on similar items.'}*/}
          {/*/>*/}
          <SelectInput
              name="active"
              label="Status"
              options={[
                { label: 'Active', value: 'Active' },
                { label: 'Inactive', value: 'Inactive' }
              ]}
              includeNone={false}
              required
              tooltipText={'Active items will be displayed in the auction app. Inactive items will be hidden.'}
          />
          <ToggleButtonGroup
              color="primary"
              value={toggleItemType}
              exclusive
              onChange={handleTypeChange}
              aria-label="Platform"
          >
            <ToggleButton classes={{ selected: '#980e0e' }} value="online-auction" title={'This item will have bidding enabled in the auction app.'}>Online Auction</ToggleButton>
            <ToggleButton  value="live-auction" title={'This item will be visible in the auction app, but online bidding is disabled. Bidding will take place in-person only.'}>Live Auction Only</ToggleButton>
            <ToggleButton  value="buy-it-now-online" title={'This item will be available for purchase in the auction app at a set price. Bidding is not allowed.'}>Buy it now only (Online)</ToggleButton>
            <ToggleButton value="buy-it-now-in-person" title={'This item will not be visible in the auction app. It will be available for purchase through the admin checkout system only.'}>Buy it now only (IN-PERSON ONLY)</ToggleButton>
          </ToggleButtonGroup>


          {(toggleItemType === 'online-auction' && allowautobidWatch) &&
              <>
              {/*</div>*/}
                <div className={styles.singleContainer}>
                  <FormControlLabel labelPlacement="start" control={
                    <Switch
                        name="allowautobid"
                        // onChange={handleAllowAutoBidChange}
                        // defaultChecked={allowAutoBidValue}
                    />
                  } label="Allow Auto Bid:" title={'Option to set a max bid that will automatically place bids on behalf of a bidder up to that amount.'}/>
                </div>
                <div className={styles.buyItNowContainer}>
                  <MaskedInput
                      decimalScale={0}
                      name="quantity"
                      label="Quantity"
                      defaultValue="1"
                      disabled={true}
                      thousandSeparator={false}
                      thousandsGroupStyle={""}
                      prefix=""
                      onValueChange={handleQuantityChange}
                      rules={{
                        validate: (val) => ((val > 0 && val <= 1000 || watch('quantityunlimited'))) || 'Please enter a number between 1 and 1000.',
                      }}
                      tooltipText={'The number of items available.'}
                  />
                  <MaskedInput
                      decimalScale={0}
                      name="startingbid"
                      label="Starting Bid"
                      defaultValue="0"
                      onValueChange={handleStartingBidChange}
                      tooltipText={'Start bidding at a higher specified amount.'}
                  />
                </div>
                <div className={styles.buyItNowContainer}>
                  <MaskedInput
                      decimalScale={0}
                      name="minimumraise"
                      label="Default Bid Increment"
                      defaultValue="1"
                      onValueChange={handleMinimumRaiseChange}
                      tooltipText={'The amount used to determine the next bid amount.'}
                  />
                  <MaskedInput
                      decimalScale={0}
                      name="fairmarketvalue"
                      label="Fair Market Value"
                      defaultValue="0"
                      onValueChange={handleFairmarketChange}
                      tooltipText={'Optional. Assign a value to the item for calculating tax benefits.'}
                  />
                </div>
                <div className={styles.buyItNowContainer}>
                  <MaskedInput
                      decimalScale={0}
                      name="buyItNowValueOnlineAuction"
                      label="Buy It Now Price (optional)"
                      // title={'The amount a user can pay to win the item immediately.'}
                      defaultValue={null}
                      required={false}
                      placeholder={"Add price to enable"}
                      onValueChange={handleBuyItNowChangeOnlineAuction}
                      tooltipText={'The amount a user can pay to win the item immediately.'}
                  />
                    {/*<NumberFormat*/}
                    {/*    name="buyitnowprice"*/}
                    {/*    customInput={TextField}*/}
                    {/*    title={'The amount a user can pay to win the item immediately.'}*/}
                    {/*    classes={{ root: styles.root }}*/}
                    {/*    className={styles.buyitnowtextContainer}*/}
                    {/*    label={(buyItNowValueOnlineAuction == undefined || buyItNowValueOnlineAuction == 0) ? "Add price to enable 1" : "Buy It Now Price"}*/}
                    {/*    defaultValue={null}*/}
                    {/*    placeholder={"Buy It Now Price (optional)"}*/}
                    {/*    thousandSeparator={true}*/}
                    {/*    thousandGroupStyle={'thousand'}*/}
                    {/*    allowNegative={false}*/}
                    {/*    value={buyItNowValueOnlineAuction > 0 ? buyItNowValueOnlineAuction : null}*/}
                    {/*    prefix="$"*/}
                    {/*    onValueChange={handleBuyItNowChangeOnlineAuction}*/}
                    {/*    size={'small' as any}*/}
                    {/*    variant="outlined"*/}
                    {/*    // InputProps={{*/}
                    {/*    //   classes: {*/}
                    {/*    //     root: styles.input,*/}
                    {/*    //     error: styles.error,*/}
                    {/*    //     focused: styles.focus*/}
                    {/*    //   },*/}
                    {/*    //   startAdornment: <InputAdornment position="start">{''}</InputAdornment>,*/}
                    {/*    //   endAdornment: <InputAdornment position="end">{''}</InputAdornment>*/}
                    {/*    // }}*/}
                    {/*    // InputLabelProps={{*/}
                    {/*    //   classes: {*/}
                    {/*    //     root: styles.label,*/}
                    {/*    //     error: styles.error,*/}
                    {/*    //     focused: styles.focus*/}
                    {/*    //   },*/}
                    {/*    //   shrink: true*/}
                    {/*    // }}*/}
                    {/*    // startAdornment={''}*/}
                    {/*    // endAdornment={''}*/}
                    {/*/>*/}
                  <TextInput name="donatedby" label="Donated By" tooltipText={'Display who donated this item on the item detail page.'}/>
                </div>
                <SelectInput
                    name="location"
                    label="Location"
                    required={true}
                    includeNone={false}
                    options={locationOptions}
                    rules={{
                      validate: (val) => (val?.length === 0 || val === 'none' || val === 0) ?  "Location is required." : clearErrors('location'),
                    }}
                    tooltipText={'The table number or other type of location grouping for the item.'}
                />
              </>
            }
          {(toggleItemType === 'online-auction' && !allowautobidWatch) &&
              <>
                <div className={styles.singleContainer}>
                  <FormControlLabel labelPlacement="start" control={
                    <Switch
                      name="allowautobid"
                      // onChange={handleAllowAutoBidChange}
                      // defaultChecked={allowAutoBidValue}
                    />} label="Allow Auto Bid:" title={'Option to set a max bid that will automatically place bids on behalf of a bidder up to that amount.'}/>
                </div>
                <div className={styles.buyItNowContainer}>
                  <Typography
                      component="div"
                      variant="body1"
                      style={{
                        position: 'relative',
                      }}
                  >
                    <CustomMaskedInput
                        decimalScale={0}
                        name="quantity"
                        label="Quantity"
                        tooltipText={'The number of items available.'}
                        defaultValue={quantityValue?.toString()}
                        disabled={watch('quantityunlimited')}
                        thousandSeparator={false}
                        thousandsGroupStyle={""}
                        prefix=""
                        onValueChange={handleQuantityChange}
                        rules={{
                          validate: (val) => ((val > 0 && val <= 1000)) || 'Please enter a number between 1 and 1000.',
                        }}

                    />
                    {/*<FormControlLabel*/}
                    {/*    className={styles.formContainer}*/}
                    {/*    labelPlacement="start" control={*/}
                    {/*  <Switch*/}
                    {/*      name="quantityunlimited"*/}
                    {/*  />*/}
                    {/*} label="Unlimited" />*/}
                  </Typography>
                  <MaskedInput
                      decimalScale={0}
                      name="startingbid"
                      label="Starting Bid"
                      tooltipText={'Start bidding at a higher specified amount.'}
                      defaultValue="0"
                      onValueChange={handleStartingBidChange}
                  />
                </div>

                <div className={styles.buyItNowContainer}>
                  <MaskedInput
                      decimalScale={0}
                      name="buyItNowValueOnlineAuction"
                      label="Buy It Now Price (optional)"
                      defaultValue={null}
                      required={false}
                      placeholder={"Add price to enable"}
                      onValueChange={handleBuyItNowChangeOnlineAuction}
                      tooltipText={'The amount a user can pay to win the item immediately.'}
                  />
                  <MaskedInput
                      decimalScale={0}
                      name="maxpurchasequantity"
                      label="Max Quantity Per Purchase"
                      tooltipText={'The number of items displayed in the quantity dropdown list while using the Buy It Now option.'}
                      defaultValue="1"
                      thousandSeparator={false}
                      thousandsGroupStyle={""}
                      prefix=""
                      rules={{
                        validate: (val) => (val > 0 && val <= 1000) || 'Please enter a number between 1 and 1000.',
                      }}
                  />
                </div>
                <div className={styles.buyItNowContainer}>
                  <MaskedInput
                      decimalScale={0}
                      name="minimumraise"
                      tooltipText={'The amount used to determine the next bid amount.'}
                      label="Default Bid Increment"
                      defaultValue="1"
                      onValueChange={handleMinimumRaiseChange}
                  />
                  <MaskedInput
                      decimalScale={0}
                      name="fairmarketvalue"
                      label="Fair Market Value"
                      tooltipText={'Optional. Assign a value to the item for calculating tax benefits.'}
                      defaultValue="0"
                      onValueChange={handleFairmarketChange}
                  />
                </div>
                <div className={styles.buyItNowContainer}>
                  <TextInput name="donatedby" label="Donated By" tooltipText={'Display who donated this item on the item detail page'}/>
                  <SelectInput
                      name="location"
                      label="Location"
                      tooltipText={'The table number or other type of location grouping for the item.'}
                      required={true}
                      includeNone={false}
                      options={locationOptions}
                      rules={{
                        validate: (val) => (val?.length === 0 || val === 'none') ?  "Location is required." : true,
                      }}
                  />
                </div>
              </>
          }
          {toggleItemType === 'live-auction' &&
              <>
                <div className={styles.buyItNowContainer}>
                  {/*<FormControlLabel labelPlacement="start" control={<Switch name="allowautobid" disabled={quantityValue > 1} />} label="Allow Auto Bid:" />*/}
                  <CustomMaskedInput
                      decimalScale={0}
                      name="quantity"
                      label="Quantity"
                      tooltipText={'The number of items available.'}
                      defaultValue={quantityValue?.toString()}
                      disabled={true}
                      // disabled={watch('quantityunlimited')}
                      thousandSeparator={false}
                      thousandsGroupStyle={""}
                      prefix=""
                      onValueChange={handleQuantityChange}
                      rules={{
                        validate: (val) => ((val > 0 && val <= 1000)) || 'Please enter a number between 1 and 1000.',
                      }}
                  />
                  <MaskedInput
                      decimalScale={0}
                      name="startingbid"
                      label="Starting Bid"
                      tooltipText={'Start bidding at a higher specified amount.'}
                      defaultValue="0"
                      onValueChange={handleStartingBidChange}
                  />
                </div>
                <div className={styles.buyItNowContainer}>
                  <MaskedInput
                      decimalScale={0}
                      name="fairmarketvalue"
                      label="Fair Market Value"
                      tooltipText={'Optional. Assign a value to the item for calculating tax benefits.'}
                      defaultValue="0"
                      onValueChange={handleFairmarketChange}
                  />
                  <TextInput name="donatedby" label="Donated By" tooltipText={'Display who donated this item on the item detail page'}/>
                </div>
                {/*<SelectInput*/}
                {/*    name="location"*/}
                {/*    label="Location"*/}
                {/*    tooltipText={'The table number or other type of location grouping for the item.'}*/}
                {/*    required={false}*/}
                {/*    options={locationOptions}*/}
                {/*/>*/}
              </>
          }

          {toggleItemType === 'buy-it-now-online' &&
              <>
              <div className={styles.buyItNowContainer}>
                <Typography
                    component="div"
                    variant="body1"
                    style={{
                      position: 'relative',
                    }}
                >
                  <NumberFormat
                      decimalScale={0}
                      name="quantity"
                      customInput={TextField}
                      title={'The number of items available.'}
                      className={styles.textContainer}
                      label="Quantity"
                      defaultValue={quantityValue?.toString()}
                      value={quantityValue?.toString()}
                      disabled={watch('quantityunlimited')}
                      thousandSeparator={false}
                      prefix=""
                      onValueChange={handleQuantityChange}
                      rules={{
                        validate: (val) => ((val > 0 && val <= 1000 || watch('quantityunlimited'))) || 'Please enter a number between 1 and 1000.',
                      }}
                      size={'small' as any}
                      variant="outlined"
                  />
                  <FormControlLabel
                      className={styles.formContainer}
                      labelPlacement="start" control={
                    <Switch
                        name="quantityunlimited"
                    />
                  } label="Unlimited" />
                </Typography>
                <MaskedInput
                    decimalScale={0}
                    name="buyItNowChangeOnlineOnly"
                    label="Buy It Now Price"
                    defaultValue={null}
                    required={true}
                    placeholder={""}
                    rules={{
                      validate: (val) => (val?.length === 0 || val === 'none' || val === 0) ?  "Buy it now price is required for Online Items." : clearErrors('buyItNowChangeOnlineOnly'),
                    }}
                    onValueChange={handleBuyItNowChangeOnlineOnly}
                    tooltipText={'The amount a user can pay to win the item immediately.'}
                />
              </div>
              <div className={styles.buyItNowContainer}>
                  <MaskedInput
                      decimalScale={0}
                      name="maxpurchasequantity"
                      label="Max Quantity Per Purchase"
                      tooltipText={'The number of items displayed in the quantity dropdown list while using the Buy It Now option.'}
                      defaultValue="1"
                      thousandSeparator={false}
                      thousandsGroupStyle={""}
                      prefix=""
                      rules={{
                        validate: (val) => (val > 0 && val <= 1000) || 'Please enter a number between 1 and 1000.',
                      }}
                  />
                  <MaskedInput
                      decimalScale={0}
                    name="fairmarketvalue"
                    label="Fair Market Value"
                    tooltipText={'Optional. Assign a value to the item for calculating tax benefits.'}
                    defaultValue="0"
                    onValueChange={handleFairmarketChange}
                  />
              </div>
              <div className={styles.buyItNowContainer}>
                <TextInput name="donatedby" label="Donated By" tooltipText={'Display who donated this item on the item detail page'}/>
                <SelectInput
                  name="location"
                  label="Location"
                  tooltipText={'The table number or other type of location grouping for the item.'}
                  required={false}
                  options={locationOptions}
                />
              </div>
              </>
          }
          {toggleItemType === 'buy-it-now-in-person' &&
              <>
                <div className={styles.buyItNowContainer}>
                  <Typography
                      component="div"
                      variant="body1"
                      style={{
                        position: 'relative',
                      }}
                  >
                    <NumberFormat
                        decimalScale={0}
                        name="quantity"
                        customInput={TextField}
                        className={styles.textContainer}
                        title={'The number of items available.'}
                        label="Quantity"
                        defaultValue={quantityValue?.toString()}
                        disabled={watch('quantityunlimited')}
                        value={quantityValue?.toString()}
                        thousandSeparator={false}
                        prefix=""
                        onValueChange={handleQuantityChange}
                        rules={{
                          validate: (val) => ((val > 0 && val <= 1000 || watch('quantityunlimited'))) || 'Please enter a number between 1 and 1000.',
                        }}
                        size={'small' as any}
                        variant="outlined"
                    />
                    <FormControlLabel
                        className={styles.formContainer}
                        labelPlacement="start" control={
                      <Switch
                          name="quantityunlimited"
                      />
                    } label="Unlimited" />
                  </Typography>
                  <MaskedInput
                      decimalScale={0}
                      name="buyitnowprice"
                      label="Buy It Now Price"
                      defaultValue={null}
                      required={true}
                      placeholder={""}
                      tooltipText={'The amount a user can pay to win the item immediately.'}
                      onValueChange={handleBuyItNowChange}
                      rules={{
                        validate: (val) => (val?.length === 0 || val === 'none' || val === 0) ?  "Buy it now price is required for Online Items." : clearErrors('buyitnowprice'),
                      }}
                  />
                </div>
                <div className={styles.buyItNowContainer}>
                  <MaskedInput
                      decimalScale={0}
                      name="maxpurchasequantity"
                      label="Max Quantity Per Purchase"
                      tooltipText={'The number of items displayed in the quantity dropdown list while using the Buy It Now option.'}
                      defaultValue="1"
                      thousandSeparator={false}
                      thousandsGroupStyle={""}
                      prefix=""
                      rules={{
                        validate: (val) => (val > 0 && val <= 1000) || 'Please enter a number between 1 and 1000.',
                      }}
                  />
                  <MaskedInput
                      decimalScale={0}
                      name="fairmarketvalue"
                      label="Fair Market Value"
                      tooltipText={'Optional. Assign a value to the item for calculating tax benefits.'}
                      defaultValue="0"
                      onValueChange={handleFairmarketChange}
                  />
                </div>
                <div className={styles.buyItNowContainer}>
                  <TextInput name="donatedby" label="Donated By" tooltipText={'Display who donated this item on the item detail page'}/>
                  {/*<SelectInput*/}
                  {/*    name="location"*/}
                  {/*    label="Location"*/}
                  {/*    tooltipText={'The table number or other type of location grouping for the item.'}*/}
                  {/*    required={false}*/}
                  {/*    options={locationOptions}*/}
                  {/*/>*/}
                </div>
              </>
          }


          <Divider textAlign={"center"}>
            <Typography variant="body2">
              Upload Image(s)
            </Typography>
          </Divider>
          <Grid container spacing={0}>
            <SortablePhotoList
              axis="xy"
              useDragHandle
              items={itemPhotos}
              onRemove={clickRemoveLogo}
              onSortEnd={onSortEnd}
              dropzoneNode={
                <div style={{ userSelect: 'none', padding: 16, margin: '0 0 8px 0', backgroundColor: 'white', border: '1px solid #ddd' }}>
                  <Dropzone onDrop={(acceptedFiles, fileRejections, event) => { console.log(fileRejections); onLogoDrop(acceptedFiles)}} onDropRejected={() => {setResetKey(resetKey +1)}} accept={[
                    'image/jpeg', 'image/jpg', 'image/*', 'image/x-png', 'image/bmp', 'image/gif', 'image/x-ms-bmp', 'image/x-bmp']}
                  >
                    {({ getRootProps, getInputProps, isDragActive, isDragAccept, isDragReject }) => (
                      <section>
                        <div {...getRootProps()} className={styles.dropzone}>
                          <input {...getInputProps()} />
                          {isDragAccept && (<h4>File is a valid image type. Go ahead and drop.</h4>)}
                          {!isDragActive && (<h4>Drag 'n' drop files here, or click to select a file</h4>)}
                          {isDragReject && (<h4>File cannot be dropped. It's an invalid type.</h4>)}
                          <h5>Item Images will be displayed with a max height of 450px. Only .jpg, .jpeg, .png, .gif, and .bmp images under 5MB are allowed.</h5>
                        </div>
                      </section>
                    )}
                  </Dropzone>
                </div>
              }
            />
            {/*{watchLogo && (*/}
            {/*    <Grid item xs={6} className={styles.selectcontrol}>*/}
            {/*      <div> <Close fontSize="small" onClick={clickRemoveLogo} /></div>*/}
            {/*      <div className={styles.logoWrapper}>*/}
            {/*        <img src={watchLogo} alt="sponsor logo" />*/}
            {/*      </div>*/}
            {/*      <div className={styles.logoWrapper}>*/}
            {/*        <img src={watchLogo} alt="sponsor logo" />*/}
            {/*      </div>*/}
            {/*    </Grid>*/}

            {/*)}*/}

            {/*<Grid item xs={6} className={styles.selectcontrol}>*/}
            {/*  {watchLogoData && (*/}
            {/*      <>*/}
            {/*        <div>New Item Image</div>*/}
            {/*        <div className={styles.logoWrapper}>*/}
            {/*          <img src={`data:image/png;base64,${watchLogoData}`} alt="event logo" />*/}
            {/*        </div>*/}
            {/*      </>*/}
            {/*  )}*/}
            {/*</Grid>*/}
          </Grid>
          {/*<Dropzone onDrop={onLogoDrop}>*/}
          {/*  {({ getRootProps,*/}
          {/*      getInputProps,*/}
          {/*      isDragActive,*/}
          {/*      isDragAccept,*/}
          {/*      isDragReject,*/}
          {/*      acceptedFiles,*/}
          {/*      fileRejections*/}
          {/*  }) => (*/}
          {/*      <section>*/}
          {/*        <h5>Upload Image</h5>*/}
          {/*        <div {...getRootProps()} className={isDragActive ? (isDragAccept ? styles.dropzoneselect : styles.dropzoneinvalid) : styles.dropzone}>*/}
          {/*          <input {...getInputProps()} />*/}
          {/*          {isDragAccept && (<h4>File is a valid image type. Go ahead and drop.</h4>)}*/}
          {/*          {!isDragActive && (<h4>Drag 'n' drop a files here, or click to select a file</h4>)}*/}
          {/*          {isDragReject && (<h4>File cannot be dropped. It's an invalid type.</h4>)}*/}
          {/*          <h5>Item Images will be displayed with a max height of 450px. Only .jpg, .jpeg, .png, .gif, and .bmp images under 5MB are allowed.</h5>*/}
          {/*        </div>*/}
          {/*      </section>*/}
          {/*  )}*/}
          {/*</Dropzone>*/}
        </HookForm>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          color="secondary"
          onClick={() => setIsOpen(false)}>
          Cancel
        </Button>
        <Button
          variant="contained"
          className={styles.submitButton}
          type="submit"
          form="items-form">
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  )
}
